import { OrderLineStatusEnum } from "@saleor/types/globalTypes";

export const pickItems = {
  __typename: "OrderLine",
  id: "",
  notes: "",
  productName: "",
  quantity: 0,
  status: OrderLineStatusEnum.PENDING,
  totalPrice: {
    __typename: "TaxedMoney",
    currency: "PHP",
    gross: {
      __typename: "Money",
      amount: 0,
      currency: "PHP"
    }
  },
  unitPrice: {
    __typename: "TaxedMoney",
    gross: { __typename: "Money", amount: 0 }
  },
  variantName: ""
};
